import { Injectable, HostListener } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, fromEvent, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiHandlerService } from '../../core/api-handlers';
import { ToastsService } from '../../core/services/toasts.service';

export interface CredentialsI {
  // Customize received credentials here
  username: string;
  // token: string;
}

export class User {
    id: number;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    accessToken: string;
}


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  public token: any = '';
  verifyData: any;

  private idleTimeout: any;  // To track inactivity
  private activityEvents: string[] = ['mousemove', 'keydown', 'click', 'scroll'];  // User activity events
  private activitySubscription: Subscription;

  constructor(
    private http: HttpClient,
    private apiHandlerService: ApiHandlerService,
    private toastService: ToastsService
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('b2cUser')));
    this.currentUser = this.currentUserSubject.asObservable();

    // Start monitoring user activity on initialization
    this.monitorUserActivity();
  }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

  /**
   * Authenticate the user here
   * @returns ture if the credentials found
   */
  isLoggedin(): Observable<boolean> {
    if (sessionStorage.getItem('adminToken') || localStorage.getItem('adminToken')) {
      return of(true);
    }
  }

onLogin(username: string, password: string): Observable<any> {
    // console.log('onLogin(username: string, password: string):', {
    //     email: username,
    //     password: password
    // });
    return this.apiHandlerService.apiHandler('userLogin', 'POST', '', '', {
        email: username,
        password: password,
        status: true, auth_role_id: 4
    }).pipe(map(res => {
        if (res['statusCode'] == 200 && res['data']['access_token'] != undefined) {
          this.verifyData =res['data'];
            // sessionStorage.setItem('b2cUser', JSON.stringify(res['data']));
            this.currentUserSubject.next(res['data']);
            /* BOF for refresh token concept */
            this.token = setInterval(() => {
                const currentUser = JSON.parse(sessionStorage.getItem('b2cUser')) || {};
                if (!currentUser.hasOwnProperty('access_token')) {
                    clearInterval(this.token);
                }
                this.apiHandlerService.apiHandler('refreshToken', 'POST', '', '', {
                    token: currentUser['access_token']
                }).pipe(
                    map(res => {
                        currentUser['access_token'] = res['data']['access_token'];
                        sessionStorage.setItem('b2cUser', JSON.stringify(currentUser));
                        this.currentUserSubject.next(currentUser);
                    })
                );
            }, Number(res['data']['JwtexpiresInSeconds']) + 24*60*60*1000);
            /* EOF for refresh token concept */
        }
        return res;
    }));
}
fetchTitleList(): Observable<any> {
return this.apiHandlerService.apiHandler('userTitleList', 'post', {}, {})
    .pipe(
        map(resp => {
            if (resp.Status)
                return {
                    statusCode: 200,
                    data: resp.data || [],
                    msg: resp.Message || 'OK'
                }
            else
                return {
                    statusCode: 404,
                    data: resp.Data || [],
                    msg: resp.Message || 'NOT FOUND'
                }
                
        }),
    
       
    );
    
}
validateOTP(login_id:string,otp: string): Observable<any> {
  return this.apiHandlerService.apiHandler('validateOTPLogin', 'POST', '', '', {
      user_id:login_id,
      otp: otp
  }).pipe(map(res => {
       this.setResponse(this.verifyData);
      return res;
  }));
}
setResponse(res){
  sessionStorage.setItem('b2cUser', JSON.stringify(res));
  // this.currentUserSubject.next(res);
  /* BOF for refresh token concept */
  this.token = setInterval(() => {
      const currentUser = JSON.parse(sessionStorage.getItem('b2cUser')) || {};
      if (!currentUser.hasOwnProperty('access_token')) {
          clearInterval(this.token);
      }
      this.apiHandlerService.apiHandler('refreshToken', 'POST', '', '', {
          token: currentUser['access_token']
      }).pipe(
          map(res => {
              currentUser['access_token'] = this.verifyData['access_token'];
              sessionStorage.setItem('b2cUser', JSON.stringify(currentUser));
              this.currentUserSubject.next(currentUser);
          })
      );
  }, this.verifyData['JwtexpiresInSeconds'] - 10);
  // Start monitoring user activity again after login
  this.monitorUserActivity();
}
  logout() {
    this.toastService.toast({ 'type': 'success', 'text': "You're Logged out" });
    sessionStorage.clear();
    localStorage.removeItem('b2cUser');
    this.currentUserSubject.next(null);

    // Stop monitoring activity and clear timers
    if (this.activitySubscription) {
      this.activitySubscription.unsubscribe();
    }
    clearTimeout(this.idleTimeout);
    clearInterval(this.token);
  }

    /**
   * Gets the user credentials.
   * @return The user credentials or null if the user is not authenticated.
   */
    get credentials(): CredentialsI | null {
      return { username: `Rajesh` };
    }

    private monitorUserActivity() {
      if (this.activitySubscription) {
        this.activitySubscription.unsubscribe();
      }
    
      // Only start monitoring if the user is logged in
      if (this.currentUserValue && this.currentUserValue.accessToken) {
        this.activitySubscription = fromEvent(document, this.activityEvents.join(' '))
          .subscribe(() => this.resetIdleTimeout());
    
        // Initialize idle timeout
        this.resetIdleTimeout();
      }
    }
    
    private resetIdleTimeout() {
      if (this.currentUserValue && this.currentUserValue.accessToken) {
        clearTimeout(this.idleTimeout);
    
        // Set a new idle timeout for 10 minutes (600,000 ms)
        this.idleTimeout = setTimeout(() => {
          this.toastService.toast({ type: 'warning', text: 'Session expired due to inactivity' });
          this.logout();
        }, 10 * 60 * 1000);  // 10 minutes
      }
    }    
}

